import React from "react";
var __jsx = React.createElement;
/** Small monitor glyph shown inside a DICOM badge; colour is inherited from the parent. */
export function DicomGlyph(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 10 10",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.4",
    "aria-hidden": "true",
    className: className
  }, /*#__PURE__*/React.createElement("rect", {
    x: "1",
    y: "2",
    width: "8",
    height: "6",
    rx: "1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 5h4M5 3.5v3"
  }));
}